import React from "react";
import moment from "moment";
import { useForm } from "react-hook-form";
import { DecisionSwal } from "Utils/Utils/DecisionSwal";
import { NumberField } from "Utils/renderField/fieldsHookForms";

// Correlativo con el que se numeran las tancadas. Mientras no esté configurado
// muestra el formulario para indicar desde qué número seguir; después, el
// resumen del período abierto y las acciones para reiniciarlo o deshacerlo.
// El reinicio es manual porque un período de producción no termina junto con
// el mes calendario
export const CorrelativoTancadas = ({ hook }) => {
    const {
        estado,
        configurado,
        periodo,
        totalPeriodos,
        tancadasNumeradas,
        siguienteNumero,
        periodoAbiertoEsteMes,
        puedeDeshacer,
        ConfigurarCorrelativo,
        ReiniciarCorrelativo,
        DeshacerPeriodo,
    } = hook;

    const {
        control: formControl,
        getValues: formGetValues,
        trigger: validateForm,
        formState: { errors: formErrors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            correlativo_inicial: "",
        },
    });

    const fechaInicio = periodo
        ? moment(periodo.fecha_inicio).format("DD/MM/YYYY HH:mm")
        : "";

    const textoTancadas = `${tancadasNumeradas} ${
        tancadasNumeradas === 1 ? "tancada" : "tancadas"
    }`;

    const ConfirmarConfiguracion = async () => {
        const valido = await validateForm();
        if (!valido) return;

        const correlativo = formGetValues("correlativo_inicial");

        let mensaje = "Las tancadas que se registren en el sistema empezarán ";
        mensaje += `a numerarse desde el ${correlativo}. El correlativo se `;
        mensaje += "reinicia de forma manual al terminar cada período de ";
        mensaje += "producción. ¿Deseas continuar?";

        DecisionSwal(mensaje, "Sí, guardar", "Cancelar", () =>
            ConfigurarCorrelativo(correlativo),
        );
    };

    const ConfirmarReinicio = () => {
        let mensaje = `El período que se cierra empezó el ${fechaInicio} y `;
        mensaje += `numeró ${textoTancadas}. Las que se registren a partir de `;
        mensaje += "ahora empezarán en 0001. ";

        // lo normal es un reinicio al mes, pero un período de producción puede
        // empezar y terminar dentro del mismo mes calendario
        if (periodoAbiertoEsteMes) {
            mensaje += "Tome en cuenta que ese período empezó este mismo mes. ";
        }

        mensaje += "¿Deseas continuar?";

        DecisionSwal(
            mensaje,
            "Sí, reiniciar",
            "Cancelar",
            ReiniciarCorrelativo,
        );
    };

    const ConfirmarDeshacer = () => {
        let mensaje = `Se deshará el período abierto el ${fechaInicio}, que `;
        mensaje += "todavía no numeró ninguna tancada. ";

        if (totalPeriodos > 1) {
            mensaje += "La numeración continúa con el período anterior. ";
        } else {
            mensaje += "No quedará ningún correlativo configurado y no se ";
            mensaje += "podrán registrar tancadas hasta volver a ";
            mensaje += "configurarlo. ";
        }

        mensaje += "¿Deseas continuar?";

        DecisionSwal(mensaje, "Sí, deshacer", "Cancelar", DeshacerPeriodo);
    };

    if (!estado) return null;

    if (!configurado) {
        return (
            <div className="mb-4">
                <p className="text-sm mb-2">
                    Antes de registrar tancadas hay que indicar{" "}
                    <b>desde qué número se van a numerar</b>. Si en este período
                    ya se registraron tancadas fuera del sistema, continúe desde
                    el número siguiente; si no, ingrese 1.
                </p>

                <div className="formulario-fields-row align-items-start justify-content-center">
                    <div
                        className="formulario-field"
                        style={{ maxWidth: "250px" }}
                    >
                        <label className="text-nowrap">
                            Correlativo inicial
                        </label>
                        <NumberField
                            control={formControl}
                            name="correlativo_inicial"
                            errors={formErrors}
                            allowNegative={false}
                            thousandSeparator={false}
                            decimalScale={0}
                            rules={{
                                required: "Debe indicar el correlativo inicial",
                                min: {
                                    value: 1,
                                    message:
                                        "El correlativo inicial debe ser mayor a cero",
                                },
                            }}
                        />
                    </div>

                    <div
                        className="formulario-field align-items-start"
                        style={{ maxWidth: "fit-content" }}
                    >
                        <button
                            className="btn btn-primary"
                            onClick={ConfirmarConfiguracion}
                            style={{ marginTop: "1.6rem" }}
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="d-flex flex-wrap align-items-center gap-1rem mb-3">
            <span className="text-sm flex-1">
                Numeración de tancadas abierta el <b>{fechaInicio}</b>, con{" "}
                <b>{textoTancadas}</b> numeradas. La siguiente será la{" "}
                <b>{siguienteNumero}</b>.
            </span>

            <div className="d-flex gap-1rem ml-auto">
                {puedeDeshacer && (
                    <button
                        className="btn btn-outline-dark btn-sm"
                        onClick={ConfirmarDeshacer}
                    >
                        Deshacer período
                    </button>
                )}

                <button
                    className="btn btn-secondary btn-sm"
                    onClick={ConfirmarReinicio}
                >
                    Reiniciar correlativo
                </button>
            </div>
        </div>
    );
};
